import { useContext } from "react";

import appContext from "../context/appContext";
import { useViewport } from "../../../components/ReactContext_Viewport";

const MobileInstructions = () => {
    const { screenSize } = useViewport();
    const { state } = useContext(appContext);

    if (screenSize !== "mobile") return null;
    return (
        <div style={{ padding: 10 }}>
            <div style={{ paddingBottom: 20 }}>
                <strong>Tap</strong> on the map to add/remove counties.
            </div>
            <div>
                <strong>{state.selectedGeos.length}</strong> counties selected.
            </div>
        </div>
    );
};
export default MobileInstructions;
